import { Controller, useForm } from 'react-hook-form';
import { ValidateUtils } from '@shared/utils';
import { BaseInput, Button, ErrorMessage, Modal, Spinner, Text } from '@shared/widgets';

interface IForm {
  password: string;
}
const DEFAULT_VALUES: IForm = { password: '' };

interface Props {
  show: boolean;
  onClose: () => void;
  onRequest: (password: string) => Promise<void>;
  mobileNumber: string;
  loading: boolean;
}

export const RequestPinModal = (props: Props) => {
  const { control, handleSubmit, reset } = useForm<IForm>({ defaultValues: DEFAULT_VALUES });

  const closeHandler = () => {
    props.onClose();
    reset(DEFAULT_VALUES);
  };
  const submitHandler = async (data: IForm) => {
    await props.onRequest(data.password);
    closeHandler();
  };

  return (
    <Modal isOpen={props.show} onClose={closeHandler} title='Request PIN'>
      {props.loading && <Spinner />}
      {!props.loading && (
        <form className='flex flex-col gap-5' onSubmit={handleSubmit(submitHandler)}>
          <Controller
            name='password'
            control={control}
            rules={{ required: ValidateUtils.requiredErrorMessage }}
            render={({ field, fieldState: { error } }) => (
              <div>
                <BaseInput {...field} type='password' placeholder='Password' />
                <ErrorMessage text={error?.message} />
              </div>
            )}
          />
          <Text weight='light' size='xs'>
            PIN will be sent to the number {props.mobileNumber}
          </Text>
          <Button fullWidth color='primary' type='submit'>
            Request PIN
          </Button>
        </form>
      )}
    </Modal>
  );
};
